import React, { useState } from 'react';
import { MIcon } from '@epo/epods-react-components/lib/Components/Icon';
import { Header } from '@epo/epods-react-components/lib/Components/Header-next';

import NavItem from './components/NavItem';
import EPOLogo from './statics/EPO-logo.gif';

import './WrappedAppbar.css';
import DropdownMenu from './components/DropdownMenu';

export const WrappedAppbar = () => {
    const [showApiMenu, setShowApiMenu] = useState('none');
    const [showDocumentationMenu, setShowDocumentationMenu] = useState('none');

    const handleShowApiMenu = () => {
        if (showApiMenu === 'none') {
            setShowApiMenu('block');
            setShowDocumentationMenu('none');
        } else {
            setShowApiMenu('none');
        }
    };

    const handleShowDocumentationMenu = () => {
        if (showDocumentationMenu === 'none') {
            setShowDocumentationMenu('block');
            setShowApiMenu('none');
        } else {
            setShowDocumentationMenu('none');
        }
    };

    const handleHideDropdownMenu = () => {
        setShowApiMenu('none');
        setShowDocumentationMenu('none');
    };

    const apiMenuItems = [
        {
            url: '/doc/application/EP',
            label: 'EP applications',
        },
        {
            url: '/data/publication/EP',
            label: 'EP publications',
        },
        {
            url: '/def/cpc/scheme',
            label: 'CPC',
        },
    ];

    const documentationMenuItems = [
        {
            url: '/documentation/data-coverage',
            label: 'Data coverage',
        },
        {
            url: '/documentation/api-overview',
            label: 'API overview',
        },
        {
            url: '/documentation/api-reference',
            label: 'API reference',
        },
        {
            url: '/documentation/patent-ontology-overview',
            label: 'Patent ontology overview',
        },
        {
            url: '/documentation/patent-ontology-reference',
            label: 'Patent ontology reference',
        },
        {
            url: '/documentation/cpc-ontology-overview',
            label: 'CPC ontology overview',
        },
        {
            url: '/documentation/cpc-ontology-reference',
            label: 'CPC ontology reference',
        },
    ];

    const MenuSection = (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '75%',
            }}
        >
            <div
                className="mr-l"
                style={{
                    whiteSpace: 'nowrap',
                }}
            >
                <NavItem className="menuItem" to="/about" label="About" onClick={handleHideDropdownMenu} />
            </div>
            <div className="mr-l" style={{ whiteSpace: 'nowrap', cursor: 'pointer' }}>
                <span
                    className="menuItem"
                    style={{ display: 'flex', alignItems: 'center' }}
                    onClick={handleShowApiMenu}
                >
                    API <MIcon size="18px" icon="expand_more" />
                </span>
                <DropdownMenu menuItems={apiMenuItems} showMenu={showApiMenu} handler={handleHideDropdownMenu} />
            </div>
            <div className="mr-l" style={{ whiteSpace: 'nowrap' }}>
                <NavItem
                    className="menuItem"
                    to="/sparql-query"
                    label="SPARQL query"
                    onClick={handleHideDropdownMenu}
                />
            </div>
            <div className="mr-l" style={{ whiteSpace: 'nowrap' }}>
                <span
                    className="menuItem"
                    style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    onClick={handleShowDocumentationMenu}
                >
                    Documentation <MIcon size="18px" icon="expand_more" />
                </span>
                <DropdownMenu
                    menuItems={documentationMenuItems}
                    showMenu={showDocumentationMenu}
                    handler={handleHideDropdownMenu}
                />
            </div>
            <div className="mr-l" style={{ whiteSpace: 'nowrap' }}>
                <NavItem className="menuItem" label="Download" to="/download" onClick={handleHideDropdownMenu} />
            </div>
            <div className="mr-l" style={{ whiteSpace: 'nowrap', textDecoration: 'none' }}>
                <a
                    className="menuItem"
                    id="contactUs"
                    href="https://www.epo.org/service-support/contact-us.html"
                    onClick={handleHideDropdownMenu}
                >
                    Contact us
                </a>
            </div>
        </div>
    );

    return (
        <div style={{ height: '100px' }} data-testid="wrapped-appbar">
            <Header
                epoLogo
                leftLayout={MenuSection}
                epoLogoSrcPath={EPOLogo}
                epoLogoTargetUrl="https://epo.org/"
                productName={"Linked open EP data"}
            />
        </div>
    );
};

export default WrappedAppbar;
